const phone = '+256782863240'
const email = 'jforce.ug@jumia.com'
const supportedLanguages = ['en']
const personalInfo = {
  phoneNumberMask: '#### ### ####'
}
const paymentMethods = {
  bankAccountMask: '### ### ####'
}

export {
  // auxiliary objects
  phone,
  email,

  // languages
  supportedLanguages,

  // personal info
  personalInfo,

  // payment methods
  paymentMethods
}
